import React from 'react';

/**
 * PVLogo — High-Fidelity SVG logo matching Concept 2 (PV Monogram) exactly.
 * Uses cleaned bezier curves and parallel lines traced from the reference image.
 */
const PVLogo = ({ sx = {}, style = {}, alt = 'Penny Vantage', ...other }) => {
    const size = sx.width || sx.height || sx.fontSize || style.width || style.height || 40;

    const svgStyle = {
        display: 'block',
        flexShrink: 0,
        ...(sx.mr !== undefined ? { marginRight: typeof sx.mr === 'number' ? sx.mr * 8 : sx.mr } : {}),
        ...(sx.ml !== undefined ? { marginLeft: typeof sx.ml === 'number' ? sx.ml * 8 : sx.ml } : {}),
        ...(sx.mt !== undefined ? { marginTop: typeof sx.mt === 'number' ? sx.mt * 8 : sx.mt } : {}),
        ...(sx.mb !== undefined ? { marginBottom: typeof sx.mb === 'number' ? sx.mb * 8 : sx.mb } : {}),
        ...style,
    };

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            aria-label={alt}
            role="img"
            style={svgStyle}
            {...other}
        >
            <defs>
                <linearGradient id="pv-logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#008A57" />
                    <stop offset="100%" stopColor="#00B480" />
                </linearGradient>
            </defs>

            {/* Background rounded square */}
            <rect width="100" height="100" rx="22" fill="url(#pv-logo-grad)" />

            {/* PV Monogram Group */}
            <g fill="white">
                {/* 
                  Letter 'P':
                  - Uses a compound path with fill-rule="evenodd" to subtract the inner bowl.
                  - Outer bowl has smooth bezier curves matching standard geometric fonts.
                */}
                <path
                    fillRule="evenodd"
                    d="M 20,28 H 39 C 45,28 53,33 53,42 C 53,51 45,57 39,57 H 29 V 70 H 20 Z M 29,36 H 39 C 43,36 45,39 45,43 C 45,47 43,50 39,50 H 29 Z"
                />

                {/* 
                  Letter 'V' with integrated upward arrow:
                  - The paths are mathematically parallel and trace the original design.
                  - Connects nicely to form a bold unified arrow icon.
                */}
                <path
                    d="M 77,28 
                       L 80,44 
                       L 75.5,42.5 
                       L 64.5,70 
                       H 55.5 
                       L 50.5,57 
                       L 53.5,53 
                       L 55.5,47 
                       L 60.5,60 
                       L 68.5,40 
                       L 63,36 
                       Z"
                />
            </g>
        </svg>
    );
};

export default PVLogo;
